
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/devices/[page]",
      function () {
        return require("private-next-pages/devices/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/devices/[page]"])
      });
    }
  